<template>
  <v-snackbar top :timeout="0" :value="getReloadNotification">
    Une nouvelle version est disponible.
    <v-btn color="success" text @click="reload">
      Mettre à jour
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ReloadNotification",
  computed: {
    ...mapGetters(["getReloadNotification"])
  },
  methods: {
    reload() {
      if (this.getReloadNotification === true) {
        this.$store.commit("setReloadNotification", false);
        window.location.reload(true);
      }
    }
  }
};
</script>

<style></style>
